'use client'

function CSSCustomization({ primaryColor }: { primaryColor: string }) {
  const baseColor = `hsl(${primaryColor})`

  return (
    <style jsx global>
      {`
        :root {
          --theme-color-primary: ${baseColor};
          --theme-color-primary-80: color-mix(in srgb, ${baseColor} 80%, white);
          --theme-color-primary-60: color-mix(in srgb, ${baseColor} 60%, white);
          --theme-color-primary-40: color-mix(in srgb, ${baseColor} 40%, white);
          --theme-color-primary-20: color-mix(in srgb, ${baseColor} 20%, white);
        }
      `}
    </style>
  )
}

export default CSSCustomization
